import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import { lazyloadVideoElement, lazyloadiFrameElement, backgroundImageLazyLoad } from 'utils/lazyload';
import { saveAs } from 'file-saver';

export default function initNewsResultsPage(){
    if($('.marker-news-archive-page').length < 1) return

    bindFilters();
	bindPagination();
}

function getOccurrences(string, subString, allowOverlapping) {

    string += "";
    subString += "";

    if (subString.length <= 0) return (string.length + 1);

    var n = 0,
    pos = 0,
    step = allowOverlapping ? 1 : subString.length;

    while (true) {

        pos = string.indexOf(subString, pos);
        if (pos >= 0) {
            ++n;
            pos += step;
        } else break;

    }

    return n;

}

function bindFilters(){
	// FILTER TOGGLE
	$('.fn-toggle-news-filters').on('click', function() {
		$('.fn-news-filters').slideToggle();
		$('.fn-toggle-news-filters.filter-icon').toggleClass("d-none");
		$('.fn-toggle-news-filters.close-filter-icon').toggleClass("d-none");
	});

    // FILTER CHANGE
	document.addEventListener('change', function(e) {

		var id	= e.target.getAttribute('id');

		//if ( 'school_category' != id && 'schools' != id  ) return;

		//e.preventDefault();
		e.target.blur();
		
		const $results	=	document.getElementById('news_search_results');
        const $category	=	document.getElementById('school_category');
		const $school	=	document.getElementById('schools');
		const $sort		=	document.getElementById('sort');

		console.log($sort)
	

		// ADD LOADING SPINNER
		//$results.classList.add('loading');

		let page_query	=	'pag=1';
		//let srch_query	=	$search.value ? '&search=' + $search.value : '';
		let school_query	=	$school.value > 0 ? '&school=' + $school.value : '';
		let category_query	=	$category.value > 0 ? '&category=' + $category.value : '';
		let sort_query	=	$sort.value  ? '&sort=' + $sort.value : 'DESC';


		// GET TOTAL RESULTS COUNT
		// fetch( config.templateDirUri + '/rest/news.php?count=1' + category_query + school_query).then(function(response) {
		// 	return response.text();

		// }).then(function(html) {
		// 	document.getElementById('results_found').innerHTML = html;
			
		// });

		// GET RESULTS AND OUTPUT HERE
		fetch( config.templateDirUri + '/rest/news.php?' + page_query + category_query + school_query + sort_query ).then(function(response) {
			console.log(response)
			return response.text();

		}).then(function(html) {
			//console.log(html)
			$results.innerHTML = html;

			// UPDATE href
			let root		=	'//' + location.host + location.pathname;
			let page		=	'?pag=1';
			//let search		=	( $search.value ? '&search=' + $search.value : '' )
			let school		=	( $school.value > 0 ? '&school=' + $school.value : '' );
			let category	=	( $category.value > 0 ? '&category=' + $category.value : '' );
			let sort		=	( $sort.value  ? '&sort=' + $sort.value : 'DESC' );


			let newQuery		=	page + category + school + sort;
			const newURL		=	root + newQuery;

			if ( window.history.replaceState ) {

				window.history.pushState( null, 'News Results', newURL );

			}

			// ADD LOADING SPINNER
			$results.classList.remove('loading');
			backgroundImageLazyLoad();

		});

	}, false );
}

function bindPagination(){
    // PAGINATION
	$(document).on( 'click', '#pagination a', function(e) {

		e.preventDefault();
		e.target.blur();
		
		const $results	=	document.getElementById('news_search_results');
		const $school	=	document.getElementById('schools');
		const $category	=	document.getElementById('school_category');
		const $sort		=	document.getElementById('sort');

		// ADD LOADING SPINNER
		$results.classList.add('loading');

		var fullQuery	=	e.target.getAttribute('href').split('?');

		const urlParams = new URLSearchParams(fullQuery[1]);

		var pageN		=	'';

		if ( urlParams.get('pag') ) {

			pageN	=	urlParams.get('pag');

		} else {

			// NO QUERY STRING PRESENT
			pageN	=	1;

		}

		let page_query	=	'pag=' + pageN;
		let school_query	=	$school.value > 0 ? '&school=' + $school.value : '';
		let category_query	=	$category.value > 0 ? '&category=' + $category.value : '';
		let sort_query		=	$sort.value  ? '&sort=' + $sort.value : 'DESC';
		//let srch_query	=	urlParams.get('search') ? '&search=' + urlParams.get('search') : '';

		// GET TOTAL RESULTS COUNT
		fetch( config.templateDirUri + '/rest/news.php?count=1'  + category_query + school_query + sort_query).then(function(response) {

			return response.text();

		}).then(function(html) {

			document.getElementById('results_found').innerHTML = html;
			
		});

		// GET RESULTS AND OUTPUT HERE
		fetch( config.templateDirUri + '/rest/news.php?' + page_query  + category_query + school_query + sort_query).then(function(response) {

			return response.text();

		}).then(function(html) {
			
			$results.innerHTML = html;

			const queryStr	=	window.location.search;
			const urlParams	=	new URLSearchParams(queryStr);

			// UPDATE href
			let root		=	'//' + location.host + location.pathname;
			let page		=	'?pag=' + pageN;
			//let search		=	( urlParams.get('search') ? '&search=' + urlParams.get('search') : '' );
			let school		=	( $school.value > 0 ? '&school=' + $school.value : '' );
			let category		=	( $category.value > 0 ? '&category=' + $category.value : '' );
			let sort		=	( $sort.value  ? '&sort=' + $sort.value : 'DESC' );

			let newQuery		=	page + category + school + sort;
			const newURL		=	root + newQuery;

			if ( window.history.replaceState ) {

				window.history.pushState( null, 'News Results', newURL );

			}

			// REMOVE LOADING SPINNER
			$results.classList.remove('loading');
			backgroundImageLazyLoad();
		});

	});
}

